import React from "react";
import { Row, Col } from "reactstrap";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory, {
  PaginationProvider,
  PaginationListStandalone,
  SizePerPageDropdownStandalone,
} from "react-bootstrap-table2-paginator";
import ToolkitProvider, {
  Search,
} from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import { formattedDate, formattedDateTime, getBookingStatus } from "../../helpers/Helper";
import filterFactory, {
  selectFilter,
  textFilter,
  dateFilter,
} from "react-bootstrap-table2-filter";
import { useNavigate, useParams } from "react-router-dom";
import { useState } from "react";
import xrayBookingsServices from "../../services/xrayBookings.services";
import { useEffect } from "react";
import ExportExcel from "../ExportExcel";
import TableNoDataIndication from "../common/TableNoDataIndication";
import { BookingStatusText, BookingStatusWithID } from "../../constants/bookingStatus";

const { SearchBar } = Search;
const UserBookingList = () => {
  const [bookings, setBookings] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedStatus, setSelectedStatus] = useState('all');
  let { id } = useParams();
  const navigate = useNavigate();
  const afterSearch = (newResult) => {
    console.log(newResult);
  };

  const getBookingDetails = async (id) => {
    const result = await xrayBookingsServices.userBookingList(id)
    // console.log('resull', result)
    if (result.status === 200) {
      const filterBooking = result.data.booking_details.map((item) => {
        if (item.booking_date) {
          // booking_date is now formatted in the table column formatter
          item.appointment_date = formattedDate(item.appointment_date);
        }
        return item
      });
      // console.log('result', result.data.booking_details)
      setBookings(filterBooking)
    }
    setLoading(false);
  }

  const selectOptions = BookingStatusText;

  const filterExcelData = bookings.map((item, index) => {
    const obj = {
      "Sr.No.": index + 1,
      "Booking Id": item.xray_booking_id,
      "App User": item.user_name || 'N/A',
      "Patient Name": item.patent_name,
      "Booking Date": formattedDateTime(item.booking_date),
      "X-ray Type": item.xray_type_name,
      "Investigation Report": item.inves_report_opted ? 'Yes' : 'No',
      "Fee Charged": item.booking_amount || 'N/A',
      "Appointment Date": formattedDate(item.appointment_date),
      "Appointment Slot": item.appointment_slot,
      "Booking Status": selectOptions[item.booking_status_id]
    }
    return obj
  })

  useEffect(() => {
    getBookingDetails(id)
  }, [])
  const tblColumn = [
    {
      dataField: "",
      text: "Sr.No.",
      formatter: (value, row, index) => {
        return <>{index + 1}</>;
      },
    },
    {
      dataField: "xray_booking_id",
      text: "Booking Id",
      sort: true,
      // filter: textFilter()
    },
    {
      dataField: "user",
      text: "App User",
      sort: true,
      formatter: (value, row) => {
        return (
          <span
            onClick={() => navigate(`/user-info/${id}`)}
            style={{ cursor: 'pointer' }}
          >
            {row.user_name || 'N/A'}
          </span>
        );
      }
    },
    {
      dataField: "patent_name",
      text: "Patient Name",
      sort: true,
      // filter: textFilter()
    },
    {
      dataField: "booking_date",
      text: "Booking Date",
      sort: true,
      formatter: (value, row) => {
        return <span>{formattedDateTime(row.booking_date)}</span>;
      },
    },
    {
      dataField: "xray_type_name",
      text: "X-ray Type",
      sort: false,
    },
    {
      dataField: "inves_report_opted",
      text: "Investigation Report",
      sort: false,
      formatter: (cell) => cell ? 'Yes' : 'No'
    },
    {
      dataField: "booking_amount",
      text: "Fee Charged",
      sort: true,
      formatter: (cell) => cell ? `${cell}` : 'N/A'
    },
    {
      dataField: "appointment_date",
      text: "Appointment Date",
      sort: true,
      // formatter: (value, row) => {
      //   return <span>{formattedDate(row.appointment_date)}</span>;
      // },
      // filter: dateFilter({
      //   delay: 400,
      //   placeholder: 'custom placeholder',
      //   withoutEmptyComparatorOption: true,
      //   // comparators: [Comparator.EQ, Comparator.GT, Comparator.LT],
      //   style: { display: 'inline-grid' },
      //   className: 'custom-datefilter-class',
      //   comparatorStyle: { backgroundColor: 'antiquewhite',display:'none' },
      //   comparatorClassName: 'custom-comparator-class',
      //   // dateStyle: { backgroundColor: 'cadetblue', margin: '0px'},
      //   dateClassName: 'custom-date-class'
      // })
    },
    {
      dataField: "appointment_slot",
      text: "Appointment Slot",
      sort: true,
    },
    {
      dataField: "booking_status_id",
      text: "Booking Status",
      formatter: (cell) => selectOptions[cell]
    },
    {
      dataField: "",
      text: "Action",
      formatter: (value, row) => {
        return (
          <span
            onClick={() => {
              navigate(`/user/bookings/detail/${row._id}`);
            }}
          >
            <i className="lni lni-eye font-size-16 me-1" />
          </span>
        );
      },
    },
  ];

  const defaultSorted = [
    {
      dataField: "_id",
      order: "desc",
    },
  ];
  // Filter bookings based on selected status
  const filteredBookings = selectedStatus === 'all'
    ? bookings
    : bookings.filter(booking => booking.booking_status_id === parseInt(selectedStatus));

  const pzipcodeOptions = {
    sizePerPzipcode: 10,
    totalSize: filteredBookings.length, // replace later with size(customers),
    custom: true,
  };


  return (
    <React.Fragment>
      <div className="page-wrapper">
        <div className="page-content-wrapper">
          <div className="page-content">
            <>
              {/*breadcrumb*/}
              <div className="page-breadcrumb d-none d-sm-flex align-items-center mb-3">
                {/* <div className="breadcrumb-title pe-3">Center</div> */}
                <div className="ps-3">
                  <nav aria-label="breadcrumb">
                    <ol className="breadcrumb mb-0 p-0">
                      <li className="breadcrumb-item">
                        <a href="#">{/* <i className="bx bx-home-alt" /> */}</a>
                      </li>
                      <li
                        className="breadcrumb-item active"
                        aria-current="page"
                      >
                        User All Bookings
                      </li>
                    </ol>
                  </nav>
                </div>
                <div className="ms-auto">
                  <div className="btn-group">
                    <button
                      className="btn btn-outline-primary me-2"
                      onClick={() => {
                        navigate("/users");
                      }}
                    >
                      <i className="bx bx plus" />
                      Return To List
                    </button>
                    <ExportExcel excelData={filterExcelData} fileName={"bookings"} />
                  </div>
                </div>
              </div>

              <div className="card">
                {/* <div className="card-header">
                                <div className="card-title">
                                    <h6 className="mb-0 pt-2 brand-color">Radiologist</h6>
                                </div>    
                            </div> */}
                <div className="card-body">
                  <div className="card-title">
                    {/* <h4 className="mb-0">Users</h4> */}
                  </div>
                  <PaginationProvider
                    pagination={paginationFactory(pzipcodeOptions)}
                    keyField="id"
                    columns={tblColumn}
                    data={filteredBookings}
                  >
                    {({ paginationProps, paginationTableProps }) => (
                      <ToolkitProvider
                        keyField="_id"
                        columns={tblColumn}
                        data={filteredBookings}
                        search={{ afterSearch }}
                      >
                        {(toolkitProps) => (
                          <React.Fragment>
                            <Row className="mb-2" style={{ display: "none" }}>
                              <Col md="4">
                                <div className="search-box me-2 mb-2 d-inline-block">
                                  <div className="status-relative"></div>
                                </div>
                              </Col>
                            </Row>
                            <Row className="mb-3">
                              <Col xl="12">
                                <div className="d-flex justify-content-end align-items-center gap-3">
                                  {/* Booking Status Dropdown */}
                                  <div className="d-flex align-items-center">
                                    <label className="pe-2 mb-0 text-nowrap">Booking Status:</label>
                                    <select
                                      className="form-select form-select-sm"
                                      style={{ minWidth: '200px' }}
                                      value={selectedStatus}
                                      onChange={(e) => setSelectedStatus(e.target.value)}
                                    >
                                      <option value="all">All Bookings</option>
                                      {Object.entries(BookingStatusText).map(([id, label]) => (
                                        <option key={id} value={id}>{label}</option>
                                      ))}
                                    </select>
                                  </div>
                                  {/* Search Bar */}
                                  <div className="d-flex align-items-center">
                                    <label className="mb-0">Search:</label>
                                    <SearchBar className="form-control form-control-sm" style={{ minWidth: '250px' }} {...toolkitProps.searchProps} />
                                  </div>
                                </div>
                                <div className="table-responsive mt-3">
                                  <BootstrapTable
                                    noDataIndication={<TableNoDataIndication loading={loading} />}
                                    keyField={"id"}
                                    responsive
                                    bordered={false}
                                    striped={false}
                                    defaultSorted={defaultSorted}
                                    classes={
                                      "table table-striped align-middle table-nowrap"
                                    }
                                    headerWrapperClasses={"thead-light"}
                                    {...toolkitProps.baseProps}
                                    {...paginationTableProps}
                                    filter={filterFactory()}
                                  />
                                </div>

                              </Col>
                            </Row>
                            {filteredBookings.length > 0 && (
                              <Row className="align-items-md-center mt-30">
                                <Col className="inner-custom-pagination mt-2 d-flex">
                                  <div className="d-inline">
                                    <SizePerPageDropdownStandalone
                                      {...paginationProps}
                                    />
                                  </div>
                                  <div className="text-md-right ms-auto">
                                    <PaginationListStandalone
                                      {...paginationProps}
                                    />
                                  </div>
                                </Col>
                              </Row>
                            )}
                          </React.Fragment>
                        )}
                      </ToolkitProvider>
                    )}
                  </PaginationProvider>
                </div>
              </div>
            </>
          </div>
        </div>
      </div>
    </React.Fragment >
  );
};

export default UserBookingList;
